module.exports = "/images/storage-concepts-quote-thumb.png?089644e2fe5e3b825288b0ebe0d68a5c";